import React, { FC, useContext } from "react";
import { useRouter } from "next/router";
import { TenantContext } from "v3/context/tenant";
import { PortalHeader as PepPortalHeader } from "@pepdirect/v3/ui/PortalHeader";
import { useLogoutUserMutation } from "v3/services/graphql/generated";
import { logUserChange } from "v3/services/analytics";
import { LocalizationContext } from "v3/context/localization";

export const PortalHeader: FC = () => {
  const { pathname } = useRouter();
  const { logoSmall, tenant } = useContext(TenantContext);
  const { localization } = useContext(LocalizationContext);
  const router = useRouter();
  const [logoutUser] = useLogoutUserMutation();

  if (
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("GxApp")
  ) {
    return null;
  }

  const fallbackUrl = tenant?.fallbackUrl || "";
  let links;

  const signOut = async () => {
    try {
      await logoutUser();
      logUserChange(null);
    } catch (e) {
      // logged in errorLink
    } finally {
      router.push(fallbackUrl);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      const currentElement = e.currentTarget as HTMLElement;
      currentElement.click();
    }
  };

  if (tenant?.brandConfig.customizations) {
    const tenantLinks = tenant.brandConfig.customizations.links;
    links = tenantLinks
      .filter((link) => link.location === "header")
      .sort((a, b) => a.position - b.position);
  }

  return (
    <PepPortalHeader
      links={links || []}
      pathname={pathname}
      fallbackUrl={fallbackUrl}
      logo={logoSmall}
      handleKeyDown={handleKeyDown}
      signOut={signOut}
      headerLocalization={localization?.portal?.header}
    />
  );
};
